var app = angular.module('directives.sliderWidgets', [])

require('./directive.js');

module.exports =  app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/sliderWidgets/index.js
 ** module id = 234
 ** module chunks = 1
 **/